import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import RemoteImageSplashDetailContainer from '../../../containers/remoteImage/splash/RemoteImageSplashDetailContainer';
import {
  REMOTE_SPLASH_IMAGE_PAGE_NAME,
  REMOTE_IMAGE_DETAIL_PAGE_TYPE,
} from '../../../constants/service/app/remoteImageConstants';

const RemoteImageSplashCreate = () => {
  return (
    <PageTemplate pageName={REMOTE_SPLASH_IMAGE_PAGE_NAME.REMOTE_SPLASH_IMAGE_CREATE}>
      <RemoteImageSplashDetailContainer detailPageType={REMOTE_IMAGE_DETAIL_PAGE_TYPE.CREATE} />
    </PageTemplate>
  );
};

export default RemoteImageSplashCreate;
